export default __webpack_public_path__ + "static/media/logo.f4a7f49f.png";